import { useSelector } from 'react-redux';
import { getUsers } from 'Selectors';

const useGetReduxUsers = () => {
    const users = useSelector(getUsers);
    return { users };
};

export default useGetReduxUsers;
